<template>
<div class="chapter">
<div class="inner_page">
<div id="Preface">
<p class="ch-title"><a id="page_7"><b>PREFACE</b></a></p><a id="page_7">
<p class="noindent1"><span class="dropcap">T</span>his is the second in a series that is intended, ultimately, to cover all the tramways of the British Isles. Its focus is on those tramway systems in Yorkshire and north-east England that operated after 1945. However, it also provides an overview of tramway development from the horse-tram era onwards in the region. Following the introduction, individual chapters deal with each of the first-generation tramways that survived into 1945, with a map that shows the system as it existed at 1 January 1945 and a fleet list of all the trams operated after that date. The Yorkshire and north-east region also includes two second-generation tramways – Sheffield Supertram and Tyne &amp; Wear Metro – which are covered.</p>
<p class="para">The majority of illustrations in the book are drawn from the collection of the Online Transport Archive; in particular, I am grateful to Barry Cross, Bob Jones, Hamish Stevenson and John Meredith, as well as to the late Drew Crighton, Marcus Eavis, Jim Joyce, Harry Luff, Phil Tatt and Tony Wickens – all of whose negatives or collections are now in the care of OTA. Martin Jenkins has been a great help in tracking down certain images and providing information. I’d also like to thank Hugh McAulay, for providing information about the tramways of Newcastle and Gateshead, and Richard Wiseman for permission to reproduce his view of Rotherham. Every effort has been made to ensure complete accuracy. Unfortunately, the records available are not always consistent and, with the passage of time, the number of those with detailed knowledge is sadly declining. Likewise every effort has been made to ensure the correct attribution of photographs. It goes without saying that any errors of fact or attribution are the author’s and any corrections should be forwarded to him care of the publishers.</p>
<p class="right"><i>Peter Waller</i>,<br/>Shrewsbury,<br/>March 2015</p>
</a></div><a id="page_7">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Preface.vue?1eb1cf80